module.exports = __webpack_public_path__ + "static/media/vnda13.9c76cbd7.png";